// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { FaqSectionFragmentDoc } from './faq/FaqSection.fragment.generated';
export const ComponentFaqFragmentDoc = gql`
    fragment componentFaq on ComponentFaq {
  showNavigation
  sections {
    ...faqSection
  }
}
    ${FaqSectionFragmentDoc}`;